import { ReactNode } from 'react';
import cn from 'classnames';
import styles from './FormFieldContainer.module.scss';

export interface FormFieldContainerProps {
  htmlFor: string;
  children: ReactNode;
  classNames?: string | string[];
  label?: string;
  footnote?: ReactNode;
  errorMessage?: ReactNode;
}

export const FormFieldContainer = ({
  htmlFor,
  classNames,
  label,
  footnote,
  errorMessage,
  children,
}: FormFieldContainerProps) => {
  const cssClasses = cn(styles.formControl, classNames, {
    [styles.hasError]: errorMessage,
  });

  return (
    <div className={cssClasses}>
      {label && <label htmlFor={htmlFor}>{label}</label>}

      {children}

      {errorMessage && (
        <div className={styles.errorMessage}>{errorMessage}</div>
      )}

      {footnote && <div className={styles.footnote}>{footnote}</div>}
    </div>
  );
};

export default FormFieldContainer;
